// PersoneBloccate.tsx — v039: chi ho bloccato (segnalando o con «Blocca»), con «Sblocca». Il blocco è sull'account,
// quindi vale anche se la persona cambia nome o nome utente: qui si vede sempre il nome di oggi.
// Chi è bloccato non può sfidarmi, chiedermi l'amicizia, vedermi tra i disponibili né entrare dove gioco io (e viceversa).
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Finestra } from "../componenti/Finestra.tsx";
import { leggiBloccati, sbloccaPersona, type Bloccato } from "../servizi/amici.ts";
import { RigaPersona } from "./Persone.tsx";

export function PersoneBloccate({ aggiorna = 0 }: { /** cambia per ricaricare (dopo un blocco nella stessa pagina) */ aggiorna?: number }) {
  const { t, i18n } = useTranslation();
  const [voci, setVoci] = useState<Bloccato[] | null>(null);
  const [aperta, setAperta] = useState(false);
  const [sblocca, setSblocca] = useState<Bloccato | null>(null);
  const [errore, setErrore] = useState(false);

  const carica = () =>
    leggiBloccati()
      .then((r) => {
        setVoci(r.voci);
        setErrore(false);
      })
      .catch(() => setErrore(true));
  useEffect(() => {
    void carica();
  }, [aggiorna]);

  if (!voci) return errore ? <p className="nota" role="alert">{t("account.errore_generico")}</p> : null;
  const data = (iso: string) => new Date(iso).toLocaleDateString(i18n.language, { day: "numeric", month: "short", year: "numeric" });
  return (
    <section className="scheda-account ld-bloccati" aria-labelledby="persone-bloccate">
      <button type="button" className="ld-bloccati-testa" aria-expanded={aperta} aria-controls="persone-bloccate-elenco" onClick={() => setAperta((a) => !a)}>
        <span className="scheda-titolo" id="persone-bloccate">
          {t("amici.bloccati_titolo", { n: voci.length })}
        </span>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true" data-aperta={aperta}>
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {aperta && (
        <div id="persone-bloccate-elenco">
          <p className="nota">{t("amici.bloccati_spiega")}</p>
          {voci.length === 0 ? (
            <p className="nota-centrata">{t("amici.bloccati_nessuno")}</p>
          ) : (
            <ul className="ld-persone ld-persone-piccole">
              {voci.map((p) => (
                <RigaPersona key={p.id} nome={p.nome} nomeUtente={p.nomeUtente} avatar={p.avatar} stato={t("amici.bloccato_il", { data: data(p.il) })}>
                  <button type="button" className="pulsante pulsante-piccolo" onClick={() => setSblocca(p)}>
                    {t("amici.sblocca")}
                  </button>
                </RigaPersona>
              ))}
            </ul>
          )}
        </div>
      )}
      <Finestra aperta={sblocca !== null} titolo={t("amici.sblocca")} onChiudi={() => setSblocca(null)}>
        <p>{t("amici.sblocca_testo", { nome: sblocca?.nome ?? "" })}</p>
        <div className="azioni-riga">
          <button type="button" className="pulsante pulsante-secondario" onClick={() => setSblocca(null)}>
            {t("generale.annulla")}
          </button>
          <button
            type="button"
            className="pulsante pulsante-primario"
            onClick={() => {
              const p = sblocca;
              setSblocca(null);
              if (p) void sbloccaPersona(p.id).finally(() => void carica());
            }}
          >
            {t("amici.sblocca")}
          </button>
        </div>
      </Finestra>
    </section>
  );
}
